import { useSelector } from "react-redux";
import { IonCard, IonItem, IonLabel, IonText } from "@ionic/react";
import { selectOrganization } from "../../../store/organizationShow/selectors/selectLocation";
export const InfoSection: React.FC = () => {
  const organization = useSelector(selectOrganization);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">General</IonText>
      </h2>
      <IonCard>
        <IonItem lines="none">
          <IonLabel>
            <p>Nombre</p>
            <h2 style={{ fontWeight: 500 }}>{organization.name}</h2>
          </IonLabel>
        </IonItem>
      </IonCard>
    </>
  );
};
